import { AppSettings } from "../Constants/AppSettings"
import { loadData, UserDataProvider } from "../Core/UserDataProvider"
import { capitalize, decodeSimplyName } from "../Helpers/Helpers"


class SeoController {

    constructor(){
        this.loadSeo()
        // this.makeDefaultTitle()
    }

    loadSeo = async () => {
        try{
            // const response = await loadData(UserDataProvider.loadTitles, {path: window.location.pathname})
            // if(response.statusCode == 200){
            //     const { title, description } = response.data
            //     this.title(title)
            //     this.description(description)
            // }
        } catch(e){
            console.log('Wrong path')
        }
    }

    makeDefaultTitle = () => {
        // console.log("MY TITLE WAS SET");

        const pathname = window.location.pathname
        if(!pathname){
            // console.error("NO PATHNAME")
            return
        }
        if(pathname.indexOf("cases")!==-1){
            this.title(`${"Our Success Stories | Wyens Co. Portfolio"}`)
            this.description(`${"Explore our portfolio showcasing successful web and mobile projects. Wyens Co. delivers exceptional digital solutions that drive growth and enhance user experience"}`)
        }
        if(pathname.indexOf("services")!==-1){
            this.title(`${"Professional Web Development & Design Services | Wyens Co"}`)
            this.description(`${"Wyens Co. offers expert web development, project coverage, mobile app development, and comprehensive design solutions. Transform your digital presence with our specialized services"}`)
        }
        if(pathname.indexOf("blogs")!==-1){
            this.title(`${"Insights & Trends in Web Development | Wyens Co Blog"}`)
            this.description(`${"Stay updated with the latest trends and insights in web development, mobile apps, and digital design. Wyens Co. Blog provides valuable content for tech enthusiasts and business owners"}`)
        }
        if(pathname.indexOf("quote")!==-1){
            this.title(`${"Get a Custom Quote for Your Project | Wyens Co"}`)
            this.description(`${"Ready to take your project to the next level? Contact Wyens Co. for a personalized quote. Our expert team is here to provide the best solutions tailored to your needs. Let’s create something extraordinary together"}`)
        }
        // this.title("BOBER TV");
    }

    title = (title: string) => {
        try {
            if(typeof title === "string"){
                document.title = `${capitalize(title)}`
            } else {
                document.title = `${AppSettings.sitename}`
            }
        } catch(e){
            console.error(e)
        }
    }

    description = (description: string ) => {
        try {
            var descriptionNew = `${AppSettings.sitename}`
            if(typeof description === "string"){
                descriptionNew = `${capitalize(description)} ${AppSettings.sitename}`
            }
            var meta=document.getElementsByTagName("meta");
            for (var i=0; i<meta.length; i++) {
                if (meta[i].name.toLowerCase()==="description") {
                    meta[i].content=descriptionNew
                }
            }
        } catch(e){
            console.error(e)
        }
    }

    url = (urlpath: string) => {
        try{
            if(window.history){
                window.history.replaceState(null, AppSettings.sitename, urlpath)
            } else {
                console.error("NO window.history")
            }
        } catch(e){

        }
    }
}


// @ts-ignore
global.__app__ = global.__app__ || {};
// @ts-ignore
global.__app__.seo =
  // @ts-ignore
  global.__app__.seo || new SeoController();

export function seo(): SeoController {
  // @ts-ignore
  return global.__app__.seo;
}